import infrastructure from '../assets/solutions/infrastructure.png';

function mobilityGrid () {
    return ({
        'E-bikes': {
            img: "https://media.deloitte.com/is/image/deloitte/in175240:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
            content: 'E-bikes merge into the fast lane',
            link: 'https://www2.deloitte.com/us/en/insights/industry/technology/smart-micromobility-e-bikes.html'
        },
        'Automation': {
            img: 'https://www.deloitte.com/content/dam/insights/articles/2024/7099_cic-future-movement-of-goods/content-images/7099-figure1.jpg',
            content: 'The journey towards a thouchless network through intelligent automation',
            link: 'https://www2.deloitte.com/us/en/insights/focus/transportation/the-role-of-intelligent-automation-in-the-movement-of-goods.html'
        },
        'Autonomous_Vehicle': {
            img: 'https://www.deloitte.com/content/dam/insights/articles/2024/6699_cir-transportation-agencies-of-the-future/content-images/6699_Figure3.png',
            content: 'The transportation agency of the future',
            link: 'https://www2.deloitte.com/us/en/insights/focus/future-of-mobility/future-of-transportation-agencies.html'
        },
        'Transportation': {
            img: 'https://www.deloitte.com/content/dam/insights/articles/2024/de114079-forget-the-wheel/content-images/fig01.png',
            content: 'Forget the wheel',
            link: 'https://www2.deloitte.com/us/en/insights/industry/automotive/reinventing-autonomous-vehicle-interiors.html'
        },
        'Autonomous_truck': {
            img: 'https://media.deloitte.com/is/image/deloitte/7031_banner-1:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off',
            content: 'Autonomous trucks lead the way',
            link: 'https://www2.deloitte.com/us/en/insights/focus/future-of-mobility/autonomous-trucks-lead-the-way.html'
        },
        'Air_Mobility': {
            img: 'https://media.deloitte.com/is/image/deloitte/6839-collection-1:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=481&dpr=off',
            content: 'Advanced air mobility',
            link: 'https://www2.deloitte.com/us/en/insights/industry/aerospace-defense/advanced-air-mobility.html',
        },
        'Electric_Vehicle': {
            img: 'https://media.deloitte.com/is/image/deloitte/22869_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=481&dpr=off',
            content: 'Electric vehicles',
            link: 'https://www2.deloitte.com/us/en/insights/focus/future-of-mobility/electric-vehicle-trends-2030.html'
        },
        'Software': {
            img: 'https://media.deloitte.com/is/image/deloitte/22951_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off',
            content: 'Software is transforming the automotive world',
            link: 'https://www2.deloitte.com/us/en/insights/focus/future-of-mobility/pure-play-software-in-automotive-industry.html',
        },
    })
}

export default mobilityGrid;